module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('frame-header'), _vm._v(" "), _c('frame-aside', {
    style: (_vm.asideMenuStyle)
  }), _vm._v(" "), _c('cros-audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "crosaudio"
  }), _vm._v(" "), _c('div', {
    style: (_vm.contentStyle),
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade-transition",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("©ZARD 2017 | Telanx")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67cc23ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Zard.vue
// module id = 101
// module chunks = 0